//redusers/meals.js
import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
    isLoadingMeal: false,
    mealData: null,
    isLoadingUpdate: false, 
    isLoadingDelete: false,
    isLoadingCreate: false,

  };

  const MealsReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_all_meals_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_all_meals_success", (state,action) => {
        state.isLoading = false;
        state.Allmeals = action.payload.meals;
        state.pagination = action.payload.pagination;
        state.totalmeals=action.payload.totalmeals
      })
      .addCase("get_all_meals_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Fillter_meals_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_meals_success", (state,action) => {
        state.isLoading = false;
        state.Filltermeals = action.payload.meals;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_Fillter_meals_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_meal_request", (state) => {
        state.isLoadingMeal = true;
      })
      .addCase("get_meal_success", (state,action) => {
        state.isLoadingMeal = false;
        state.mealData = action.payload;
      })
      .addCase("get_meal_error", (state,action) => {
        state.isLoadingMeal = false;
        state.err = action.payload;
      })
      .addCase("create_meal_request", (state) => {
        state.isLoadingCreate = true;
      })
      .addCase("create_meal_success", (state,action) => {
        state.isLoadingCreate = false;
        state.Createdmeal = action.payload;

      })
      .addCase("create_meal_error", (state,action) => {
        state.isLoadingCreate = false;
        state.errCreate = action.payload;
      })
      .addCase("update_meal_request", (state) => {
        state.isLoadingUpdate = true;
      })
      .addCase("update_meal_success", (state,action) => {
        state.isLoadingUpdate = false;
        state.Updatedmeal = action.payload;
      })
      .addCase("update_meal_error", (state,action) => {
        state.isLoadingUpdate = false;
        state.err = action.payload;
      })

      .addCase("get_FillterWithSort_meals_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_FillterWithSort_meals_success", (state,action) => {
        state.isLoading = false;
        state.FilltermealsWithSort = action.payload.meals;
        state.FilterpaginationWithSort = action.payload.pagination;
      })
      .addCase("get_FillterWithSort_meals_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("delete_meal_request", (state) => {
        state.isLoadingDelete = true;
      })
      .addCase("delete_meal_success", (state,action) => {
        state.isLoadingDelete = false;
        state.DeleteMessage = action.payload;
      })
      .addCase("delete_meal_error", (state,action) => {
        state.isLoadingDelete = false;
        state.err = action.payload;
      })
      .addCase("clear_error", (state) => {
        state.err = null;
        state.DeleteMessage = null;
        state.Updatedmeal = null;
        state.isLoadingDelete = false;
       state.isLoadingUpdate = false;
       state.isLoadingCreate = false;
       state.errCreate=false;
      

      });
      
  });

  
  export default MealsReducer;